import { RecaptchaProvider } from '../../components/provider/RecaptchaProvider.jsx';
import { Link, useNavigate } from 'react-router';
import RecaptchaV3 from '../../components/GoogleRecaptcha-v3.jsx';
import { toast } from 'react-toastify';
import React, { useContext, useEffect, useState } from 'react';
import { getToken, setCurrentUser, setRefreshToken, setToken } from '../../utils/Sessions.jsx';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import logo from '../../assets/logo_ys.png';
import { BInput, BPassword } from '../../components/ui/form';
import { BAlert, BButton } from '../../components/ui/generic';
import UserEmailContext from '../../context/UserEmailContext.jsx';
import { requiredField } from '../../utils';

const Home = () => {
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useContext(UserEmailContext);
  useEffect(() => {
    if (getToken()) navigate('/');
  }, [navigate]);

  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      email: userEmail || '',
    },
  });

  const handleLoginForm = async (data) => {
    setError('');
    if (!data?.captcha) {
      setError('Le captcha n’est plus valide. Veuillez rafraîchir la page pour continuer.');
      return;
    }
    if (!data?.email) {
      setError('Merci de saisir une adresse email valide.');
      return;
    }

    if (!data?.password) {
      setError('Merci de saisir votre mot de passe');
      return;
    }

    await axios
      .post(`${import.meta.env.VITE_API_BASE_URL}/internal_api/login`, data)
      .then((callback) => {
        if (callback?.data?.token) {
          setToken(callback?.data?.token);
          setRefreshToken(callback?.data?.refresh_token);
          setCurrentUser(JSON.stringify(callback?.data?.user));
          navigate('/');
        } else {
          setError(callback?.data?.message);
        }
      })
      .catch((error) => {
        setError('Une erreur est survenue.');
      });
  };

  return (
    <div
      className={`bg-primary-900 to-primary-900 font-poppins flex min-h-screen w-full flex-col items-center justify-center gap-8 bg-gradient-to-l from-purple-900 px-8 text-slate-700 lg:flex-row lg:px-24`}
    >
      <div className={'flex w-full flex-col items-center gap-4 text-white'}>
        <img src={logo} alt="Logo" className={'w-fit'} />
        <div className={'flex flex-col gap-4'}>
          <p className={'text-2xl font-medium lg:text-6xl'}>Mon espace candidat</p>
          <p className={'font-medium lg:text-4xl'}>Bienvenue sur votre portail</p>
        </div>
      </div>
      <div className={`flex w-full max-w-md items-center justify-center rounded bg-white p-4 shadow`}>
        <RecaptchaProvider>
          <form onSubmit={handleSubmit(handleLoginForm)} className={'flex w-full flex-col gap-2 px-6'}>
            <p className={'text-lg font-medium'}>Connexion</p>

            <BInput
              label={'Email'}
              type={'email'}
              {...register('email', { required: { value: true, message: requiredField } })}
            />
            {errors.email && <p className={'text-sm text-red-600'}>{errors.email.message}</p>}

            <BPassword
              label={'Mot de passe'}
              {...register('password', { required: { value: true, message: requiredField } })}
            />
            {errors.password && <p className={'text-sm text-red-600'}>{errors.password.message}</p>}

            <RecaptchaV3 setValue={setValue} />

            <div>
              <BButton isDisabled={isSubmitting} isProcessing={isSubmitting} type={'submit'} label={'Envoyer'} />
            </div>
            {error && <BAlert color={'error'}>{error}</BAlert>}

            <Link className={`text-sm text-blue-500`} to={`/recuperation-mot-de-passe`}>
              Mot de passe oublié ?
            </Link>
          </form>
        </RecaptchaProvider>
      </div>

      {/*      <TestSentry />*/}
    </div>
  );
};

const TestSentry = () => {
  return (
    <button
      className={`rounded border border-white p-2 text-white`}
      onClick={() => {
        throw new Error('This is your first error!');
      }}
    >
      Break the world
    </button>
  );
};

export default Home;
